module.exports = __webpack_public_path__ + "img/gas.a62463ee.svg";